/** Regra clássica brasileira: etanol tende a valer se ≤ 70% do preço da gasolina. */
export const LIMITE_ETANOL_PADRAO = 0.7;

/**
 * Compara etanol vs gasolina.
 * Com consumos (km/L): usa custo por km.
 * Sem consumos: usa a regra dos 70%.
 */
export function simularEtanolGasolina({
    precoEtanol,
    precoGasolina,
    kmLEtanol = null,
    kmLGasolina = null,
    limiteRazao = LIMITE_ETANOL_PADRAO,
}) {
    const e = Number(precoEtanol);
    const g = Number(precoGasolina);
    if (![e, g].every((v) => Number.isFinite(v) && v > 0)) return null;

    const razao = e / g;
    const limite = Number(limiteRazao) > 0 ? Number(limiteRazao) : LIMITE_ETANOL_PADRAO;
    const limitePct = limite * 100;

    const kmE = kmLEtanol != null ? Number(kmLEtanol) : null;
    const kmG = kmLGasolina != null ? Number(kmLGasolina) : null;
    const temConsumo = Number.isFinite(kmE) && kmE > 0 && Number.isFinite(kmG) && kmG > 0;

    if (temConsumo) {
        const custoKmE = e / kmE;
        const custoKmG = g / kmG;
        const melhor = custoKmE < custoKmG ? 'etanol' : custoKmG < custoKmE ? 'gasolina' : 'empate';
        const economiaKm = Math.abs(custoKmE - custoKmG);

        return {
            modo: 'consumo',
            razao,
            razaoPct: razao * 100,
            limite,
            limitePct,
            custoKmEtanol: custoKmE,
            custoKmGasolina: custoKmG,
            melhor,
            economiaKm,
            veredicto: buildVeredictoConsumo(melhor, economiaKm, custoKmE, custoKmG),
        };
    }

    const melhor = razao < limite ? 'etanol' : razao > limite ? 'gasolina' : 'empate';
    return {
        modo: 'regra70',
        razao,
        razaoPct: razao * 100,
        limite,
        limitePct,
        custoKmEtanol: null,
        custoKmGasolina: null,
        melhor,
        economiaKm: null,
        veredicto: buildVeredictoRegra(melhor, razao * 100, limitePct, e, g),
    };
}

function buildVeredictoConsumo(melhor, economiaKm, custoKmE, custoKmG) {
    if (melhor === 'empate') {
        return {
            tipo: 'empate',
            titulo: 'Empate no custo por km',
            detalhe: 'Com o consumo informado, etanol e gasolina saem iguais.',
        };
    }
    const nome = melhor === 'etanol' ? 'Etanol' : 'Gasolina';
    return {
        tipo: 'positivo',
        titulo: `Vale ${nome}`,
        detalhe: `Custo por km: etanol ${custoKmE.toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' })} · gasolina ${custoKmG.toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' })}. Diferença de ${economiaKm.toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' })}/km.`,
    };
}

function buildVeredictoRegra(melhor, razaoPct, limitePct, e, g) {
    const precoLimite = g * (limitePct / 100);
    if (melhor === 'empate') {
        return {
            tipo: 'empate',
            titulo: 'No limite da regra',
            detalhe: `O etanol está em exatamente ${limitePct.toLocaleString('pt-BR', { maximumFractionDigits: 0 })}% da gasolina.`,
        };
    }
    if (melhor === 'etanol') {
        return {
            tipo: 'positivo',
            titulo: 'Vale etanol',
            detalhe: `Etanol está a ${razaoPct.toLocaleString('pt-BR', { maximumFractionDigits: 1 })}% da gasolina (abaixo de ${limitePct.toLocaleString('pt-BR', { maximumFractionDigits: 0 })}%). Limite sugerido: até ${precoLimite.toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' })}.`,
        };
    }
    return {
        tipo: 'atencao',
        titulo: 'Vale gasolina',
        detalhe: `Etanol está a ${razaoPct.toLocaleString('pt-BR', { maximumFractionDigits: 1 })}% da gasolina (acima de ${limitePct.toLocaleString('pt-BR', { maximumFractionDigits: 0 })}%). Para valer, etanol precisaria custar até ${precoLimite.toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' })}.`,
    };
}
